<template>
  <div
    class="task-table-container"
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <!-- 顶部搜索栏 -->
    <div class="search-bar">
      <el-input
        v-model="searchParams.name"
        placeholder="请输入任务名称"
        clearable
        style="width: 220px"
      ></el-input>

      <!-- 任务类型筛选 -->
      <el-select
        v-model="searchParams.type"
        placeholder="请选择任务类型"
        clearable
        style="width: 180px"
      >
        <el-option label="定时任务" :value="1"></el-option>
        <el-option label="普通任务" :value="2"></el-option>
      </el-select>

      <el-button type="primary" icon="el-icon-search" @click="getTaskList">
        搜索
      </el-button>
      <el-button icon="el-icon-refresh" @click="resetSearch"> 重置 </el-button>
    </div>

    <!-- PC 表格（移动端隐藏） -->
    <el-table
    height="900"
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column label="ID" prop="id" width="80" align="center" />
      <el-table-column label="任务编号" prop="task_num" width="120" />
      <el-table-column label="任务名称" prop="name" min-width="200" />
      
      <!-- 任务类型列 -->
      <el-table-column label="任务类型" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.type == 1 ? 'warning' : 'success'">
            {{ scope.row.type == 1 ? '定时任务' : '普通任务' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="执行间隔"
        prop="interval_time"
        width="100"
        align="center"
      />
      <el-table-column
        label="执行方法"
        prop="find_class_method"
        min-width="300"
        show-overflow-tooltip
      />
      <el-table-column label="创建时间" prop="created_at" width="180" />
      <el-table-column label="更新时间" prop="updated_at" width="180" />

      <!-- 操作列 -->
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="openPcEdit(scope.row)"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 移动端卡片列表（PC隐藏） -->
    <div class="mobile-card-list">
      <div
        class="mobile-card"
        v-for="item in tableData"
        :key="item.id"
      >
        <div class="card-top">
          <div class="label">编号：{{ item.task_num }}</div>
          <el-tag :type="item.type == 1 ? 'warning' : 'success'">
            {{ item.type == 1 ? '定时任务' : '普通任务' }}
          </el-tag>
        </div>
        <div class="card-body">
          <div><span>任务名称：</span>{{ item.name }}</div>
          <div><span>执行间隔：</span>{{ item.interval_time }}</div>
          <div><span>执行方法：</span>{{ item.find_class_method }}</div>
          <div><span>创建时间：</span>{{ item.created_at }}</div>
          <div><span>更新时间：</span>{{ item.updated_at }}</div>
        </div>
        <div class="card-footer">
          <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-edit"
            @click="openMobileEdit(item)"
          >
            编辑
          </el-button>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchParams.page"
      :page-size="searchParams.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total"
      style="margin-top: 20px; text-align: right"
            pager-count="2"
            small
    ></el-pagination>

    <!-- PC 端独立编辑弹窗 -->
    <el-dialog
      title="PC 编辑任务"
      :visible.sync="pcEditVisible"
      width="600px"
      @close="resetPcForm"
      append-to-body
    >
      <el-form
        :model="pcEditForm"
        :rules="editRules"
        ref="pcEditForm"
        label-width="110px"
      >
        <el-form-item label="任务ID" prop="id">
          <el-input v-model="pcEditForm.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务编号" prop="task_num">
          <el-input v-model="pcEditForm.task_num" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务名称" prop="name">
          <el-input v-model="pcEditForm.name" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="任务类型" prop="type">
          <el-select v-model="pcEditForm.type" placeholder="请选择任务类型">
            <el-option label="定时任务" :value="1"></el-option>
            <el-option label="普通任务" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执行间隔" prop="interval_time">
          <el-input v-model="pcEditForm.interval_time" placeholder="请输入执行间隔"></el-input>
        </el-form-item>
        <el-form-item label="执行方法" prop="find_class_method">
          <el-input v-model="pcEditForm.find_class_method" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pcEditVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPcEdit">确认修改</el-button>
      </div>
    </el-dialog>

    <!-- 移动端独立编辑弹窗 -->
    <el-dialog
      title="移动端编辑任务"
      :visible.sync="mobileEditVisible"
      width="90%"
      custom-class="mobile-full-dialog"
      @close="resetMobileForm"
      append-to-body
    >
      <el-form
        :model="mobileEditForm"
        :rules="editRules"
        ref="mobileEditForm"
        label-width="100px"
      >
        <el-form-item label="任务ID" prop="id">
          <el-input v-model="mobileEditForm.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务编号" prop="task_num">
          <el-input v-model="mobileEditForm.task_num" disabled></el-input>
        </el-form-item>
        <el-form-item label="任务名称" prop="name">
          <el-input v-model="mobileEditForm.name" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="任务类型" prop="type">
          <el-select v-model="mobileEditForm.type" placeholder="请选择任务类型">
            <el-option label="定时任务" :value="1"></el-option>
            <el-option label="普通任务" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="执行间隔" prop="interval_time">
          <el-input v-model="mobileEditForm.interval_time" placeholder="请输入执行间隔"></el-input>
        </el-form-item>
        <el-form-item label="执行方法" prop="find_class_method">
          <el-input v-model="mobileEditForm.find_class_method" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mobileEditVisible = false">取消</el-button>
        <el-button type="primary" @click="submitMobileEdit">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "TaskTable",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: { page: 1, page_size: 10, name: "", type: "" },
      pageSizes: [10, 20, 50, 100],

      // PC 独立编辑
      pcEditVisible: false,
      pcEditForm: {
        id: "",name: "",type: "",interval_time: "",task_num: "",find_class_method: ""
      },

      // 移动端独立编辑
      mobileEditVisible: false,
      mobileEditForm: {
        id: "",name: "",type: "",interval_time: "",task_num: "",find_class_method: ""
      },

      // 共用规则
      editRules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择任务类型", trigger: "change" }],
      },
    };
  },
  created() {
    this.getTaskList();
  },
  methods: {
    // 获取任务列表
    getTaskList() {
      this.loading = true;
      api.task
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ========== PC 编辑逻辑 ==========
    openPcEdit(row) {
      this.pcEditForm = { ...row };
      this.pcEditVisible = true;
    },
    submitPcEdit() {
      this.$refs.pcEditForm.validate(valid => {
        if (!valid) return;
        this.loading = true;
        api.task.edit(this.pcEditForm).then(res => {
          if (res.data.code == 1000) {
            this.getTaskList();
            this.pcEditVisible = false;
          }
        }).finally(() => this.loading = false);
      });
    },
    resetPcForm() {
      this.pcEditForm = { id: "",name: "",type: "",interval_time: "",task_num: "",find_class_method: "" };
      this.$refs.pcEditForm.clearValidate();
    },

    // ========== 移动端编辑逻辑 ==========
    openMobileEdit(row) {
      this.mobileEditForm = { ...row };
      this.mobileEditVisible = true;
    },
    submitMobileEdit() {
      this.$refs.mobileEditForm.validate(valid => {
        if (!valid) return;
        this.loading = true;
        api.task.edit(this.mobileEditForm).then(res => {
          if (res.data.code == 1000) {
            this.getTaskList();
            this.mobileEditVisible = false;
          }
        }).finally(() => this.loading = false);
      });
    },
    resetMobileForm() {
      this.mobileEditForm = { id: "",name: "",type: "",interval_time: "",task_num: "",find_class_method: "" };
      this.$refs.mobileEditForm.clearValidate();
    },

    // 搜索重置
    resetSearch() {
      this.searchParams.name = "";
      this.searchParams.type = "";
      this.getTaskList();
    },

    // 分页
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getTaskList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getTaskList();
    },
  },
};
</script>

<style scoped>
.task-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.dialog-footer {
  text-align: right;
}

/* 移动端卡片样式 */
.mobile-card-list {
  display: none;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 10px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.9;
  margin-bottom: 10px;
}
.card-body span {
  color: #999;
  display: inline-block;
  width: 72px;
}
.card-footer {
  text-align: right;
}

/* 响应式 */
@media (max-width: 768px) {
  .el-table {
    display: none !important;
  }
  .mobile-card-list {
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/operate/task.vue